module.exports = __webpack_public_path__ + "static/media/bfile-457.576491b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-457.svg
// module id = 256
// module chunks = 0